export function getDefinitiveNode<R extends HTMLElement>(selector: string, root = document.body): R {
  const element = root.querySelector<R>(selector);
  if (!element) {
    throw new Error(`Element with selector "${selector}" not found.`);
  }
  return element;
}
